import React, { ReactElement, Fragment, useEffect, useState } from 'react';
import { Navbar, Nav, Dropdown, Container } from 'react-bootstrap';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { UserIcon, SignOutIcon } from 'react-line-awesome';
import { useHistory } from 'react-router-dom';
import { Login } from 'presentation/components';
import AuthContext, { AuthenticationContext } from 'presentation/Context/Auth';
import Routes from 'presentation/routes';
import { AuthRepository } from 'infraestructure/repositories';
import './index.css';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import { useScrollDirection } from './useScrollDirection';

import { useBrand } from 'core/contexts/BrandContext';
export interface NavBarMenuItem {
  url: string;
  title: string;
  country: string;
}

export interface NavBarProps {
  items: NavBarMenuItem[];
  isMobile?: boolean;
}

export const ItemsMenu = (props: NavBarProps): ReactElement => {
  const [menuSite, setMenuSite] = useState<NavBarMenuItem[]>([]);
  const history = useHistory();
  const location = useLocation();
  const context = React.useContext<AuthenticationContext>(AuthContext);
  const { country, features } = useBrand();
  const { isMobile } = props;

  const isChildActive = (urls: string[]): boolean => {
    return urls.some((url) => location.pathname === url);
  };

  useEffect(() => {
    let filtered = props.items.filter(
      (itemMenu) => itemMenu.country === country
    );
    if (!features.hasFactoring) {
      filtered = filtered.filter((item) => item.title !== 'Factoring');
    }
    if (!features.hasInvestments) {
      filtered = filtered.filter((item) => item.title !== 'Inversiones');
    }
    setMenuSite(filtered);
  }, [props.items, country, features]);

  const paymentPointsItems = menuSite.filter(
    (item) =>
      item.title === 'Linea Revolvente y Tarjeta Privada' ||
      item.title === 'Tarjeta de Credito Mastercard'
  );

  const loyaltyProgramItem = menuSite.find(
    (item) => item.title === 'Programa de Lealtad'
  );
  const downloadAppItem = menuSite.find(
    (item) =>
      item.title === 'Descargá ZüApp' ||
      item.title === 'Descargar ZüApp' ||
      item.url === Routes.downloadApp
  );
  const customerServiceItem = menuSite.find(
    (item) =>
      item.title === 'Servicio al Cliente' ||
      item.title === 'Customer Service' ||
      item.url === '/customerservice' ||
      item.url === '/servicioalcliente'
  );

  const commerceItems = menuSite.filter(
    (item) =>
      item.title === 'Comercios Afiliados' ||
      item.title === 'Centro de Capacitación'
  );

  // Filtramos para que ninguno de estos salga como principal (used for NI rendering)
  let otherMenuItems = menuSite.filter(
    (item) =>
      item.title !== 'Puntos de Pago' &&
      item.title !== 'Programa de Lealtad' &&
      item.title !== 'Descargá ZüApp' &&
      item.title !== 'Descargar ZüApp' &&
      item.title !== 'Servicio al Cliente' &&
      item.title !== 'Customer Service' &&
      item.url !== Routes.downloadApp &&
      item.url !== '/customerservice' &&
      item.url !== '/servicioalcliente' &&
      item.url !== Routes.dashboard &&
      item.title !== 'Mi cuenta' &&
      item.title !== 'Mi Cuenta' &&
      !paymentPointsItems.includes(item)
  );

  // If GT, remove commerce items from main list so they only appear in the dropdown
  otherMenuItems = otherMenuItems.filter(
    (item) =>
      item.title !== 'Comercios Afiliados' &&
      item.title !== 'Centro de Capacitación'
  );

  const firstItems = otherMenuItems.slice(0, 2);
  const remainingItems = otherMenuItems.slice(2);

  const handleRedirect = (url: string) => {
    history.push(url);
  };

  const inicioItem = menuSite.find((item) => item.title === 'Inicio');
  const nosotrosItem = menuSite.find((item) => item.title === 'Nosotros');
  const efectivoItem = menuSite.find(
    (item) => item.title === 'Efectivo de inmediato'
  );
  const puntosItem = menuSite.find((item) => item.title === 'Puntos de Pago');

  const MobileDropdownItem = ({ title, items, activeUrls }: { title: string, items: NavBarMenuItem[], activeUrls: string[] }) => {
    const [open, setOpen] = useState(false);
    return (
      <div className={`nav-item dropdown ${open ? 'show' : ''}`}>
        <div 
          className={`nav-link dropdown-toggle ${isChildActive(activeUrls) ? 'active' : ''}`}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(!open); }}
          style={{ cursor: 'pointer' }}
        >
          {title}
        </div>
        <div className={`dropdown-menu ${open ? 'show' : ''}`} style={{ position: 'static', float: 'none', transform: 'none', display: open ? 'block' : 'none' }}>
          {items.map((item, index) => (
            <Dropdown.Item key={index} onClick={() => handleRedirect(item.url)}>
              {item.title}
            </Dropdown.Item>
          ))}
        </div>
      </div>
    );
  };

  // Use feature flag for GT/Zu vs Credex rendering
  if (!features.hasPaymentPointsDropdown) {
    return (
      <Fragment>
        {inicioItem && (
          <NavLink
            exact
            activeClassName="active"
            className="nav-link"
            to={inicioItem.url}
          >
            {inicioItem.title}
          </NavLink>
        )}

        {nosotrosItem && (
          <NavLink
            exact
            activeClassName="active"
            className="nav-link"
            to={nosotrosItem.url}
          >
            {nosotrosItem.title}
          </NavLink>
        )}

        {commerceItems.length > 0 && (
          isMobile ? (
            <MobileDropdownItem title="Comercios" items={commerceItems} activeUrls={commerceItems.map(i => i.url)} />
          ) : (
            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle
                as={Nav.Link}
                id="dropdown-commerce"
                className={
                  isChildActive(commerceItems.map((i) => i.url)) ? 'active' : ''
                }
              >
                Comercios
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {commerceItems.map((item, index) => (
                  <Dropdown.Item
                    key={index}
                    onClick={() => handleRedirect(item.url)}
                  >
                    {item.title}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          )
        )}

        {efectivoItem && (
          <NavLink
            exact
            activeClassName="active"
            className="nav-link"
            to={efectivoItem.url}
          >
            {efectivoItem.title}
          </NavLink>
        )}

        {puntosItem && (
          <NavLink
            exact
            activeClassName="active"
            className="nav-link"
            to={puntosItem.url}
          >
            {puntosItem.title}
          </NavLink>
        )}

        {customerServiceItem && (
          isMobile ? (
            <MobileDropdownItem 
              title={customerServiceItem.title} 
              items={[
                { title: 'Atención al Cliente', url: customerServiceItem.url, country },
                { title: 'Verificación de Finiquito', url: Routes.finiquitoVerification, country }
              ]} 
              activeUrls={[customerServiceItem.url, Routes.finiquitoVerification]} 
            />
          ) : (
            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle
                as={Nav.Link}
                id="dropdown-customer-service-gt"
                className={
                  isChildActive([
                    customerServiceItem.url,
                    Routes.finiquitoVerification,
                  ])
                    ? 'active'
                    : ''
                }
              >
                {customerServiceItem.title}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => handleRedirect(customerServiceItem.url)}
                >
                  Atención al Cliente
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => handleRedirect(Routes.finiquitoVerification)}
                >
                  Verificación de Finiquito
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )
        )}

        {context.isLogged && (
          <NavLink
            exact
            activeClassName="active"
            className="nav-link"
            to={Routes.dashboard}
          >
            Mi Cuenta
          </NavLink>
        )}
      </Fragment>
    );
  }

  // NI: keep previous behavior (show items as they come, including 'Comercios Afiliados')
  return (
    <Fragment>
      {firstItems.map((itemMenu, index) => (
        <NavLink
          exact
          activeClassName="active"
          className="nav-link"
          to={itemMenu.url}
          key={index}
        >
          {itemMenu.title}
        </NavLink>
      ))}

      {commerceItems.length > 0 && (
        isMobile ? (
          <MobileDropdownItem title="Comercios" items={commerceItems} activeUrls={commerceItems.map(i => i.url)} />
        ) : (
          <Dropdown as={Nav.Item}>
            <Dropdown.Toggle
              as={Nav.Link}
              id="dropdown-commerce"
              className={
                isChildActive(commerceItems.map((i) => i.url)) ? 'active' : ''
              }
            >
              Comercios
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {commerceItems.map((item, index) => (
                <Dropdown.Item
                  key={index}
                  onClick={() => handleRedirect(item.url)}
                >
                  {item.title}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )
      )}

      {/* Para GT, mostrar solo 'Puntos de Pago' como enlace simple; para NI, mantener dropdown */}
      {features.hasPaymentPointsDropdown ? (
        isMobile ? (
          <MobileDropdownItem title="Puntos de Pago" items={paymentPointsItems} activeUrls={paymentPointsItems.map(i => i.url)} />
        ) : (
          <Dropdown as={Nav.Item}>
            <Dropdown.Toggle
              as={Nav.Link}
              id="dropdown-custom-components"
              className={
                isChildActive(paymentPointsItems.map((i) => i.url))
                  ? 'active'
                  : ''
              }
            >
              Puntos de Pago
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {paymentPointsItems.map((item, index) => (
                <Dropdown.Item
                  key={index}
                  onClick={() => handleRedirect(item.url)}
                >
                  {item.title}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )
      ) : (
        // Para GT, buscar el ítem 'Puntos de Pago' y mostrarlo como enlace simple
        (() => {
          const paymentPointItem = menuSite.find(
            (item) => item.title === 'Puntos de Pago'
          );
          return paymentPointItem ? (
            <NavLink
              exact
              activeClassName="active"
              className="nav-link"
              to={paymentPointItem.url}
            >
              {paymentPointItem.title}
            </NavLink>
          ) : null;
        })()
      )}

      {/* Ajuste: Para GT solo mostrar Servicio al Cliente como ítem simple, para NI mantener dropdown */}
      {features.hasPaymentPointsDropdown
        ? (customerServiceItem || loyaltyProgramItem || downloadAppItem) && (
            isMobile ? (
              <MobileDropdownItem 
                title="Atención al Cliente" 
                items={[
                  ...(customerServiceItem ? [{ title: customerServiceItem.title, url: customerServiceItem.url, country }] : []),
                  ...(loyaltyProgramItem ? [{ title: loyaltyProgramItem.title, url: loyaltyProgramItem.url, country }] : []),
                  ...(downloadAppItem ? [{ title: downloadAppItem.title, url: downloadAppItem.url, country }] : [])
                ]} 
                activeUrls={[
                  customerServiceItem?.url || '',
                  loyaltyProgramItem?.url || '',
                  downloadAppItem?.url || '',
                ].filter(Boolean)} 
              />
            ) : (
              <Dropdown as={Nav.Item}>
                <Dropdown.Toggle
                  as={Nav.Link}
                  id="dropdown-customer-service"
                  className={
                    isChildActive(
                      [
                        customerServiceItem?.url || '',
                        loyaltyProgramItem?.url || '',
                        downloadAppItem?.url || '',
                      ].filter(Boolean)
                    )
                      ? 'active'
                      : ''
                  }
                >
                  Atención al Cliente
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {customerServiceItem && (
                    <Dropdown.Item
                      onClick={() => handleRedirect(customerServiceItem.url)}
                    >
                      {customerServiceItem.title}
                    </Dropdown.Item>
                  )}
                  {loyaltyProgramItem && (
                    <Dropdown.Item
                      onClick={() => handleRedirect(loyaltyProgramItem.url)}
                    >
                      {loyaltyProgramItem.title}
                    </Dropdown.Item>
                  )}
                  {downloadAppItem && (
                    <Dropdown.Item
                      onClick={() => handleRedirect(downloadAppItem.url)}
                    >
                      {downloadAppItem.title}
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            )
          )
        : customerServiceItem && (
            <NavLink
              exact
              activeClassName="active"
              className="nav-link"
              to={customerServiceItem.url}
            >
              {customerServiceItem.title}
            </NavLink>
          )}

      {remainingItems.map((itemMenu, index) => (
        <NavLink
          exact
          activeClassName="active"
          className="nav-link"
          to={itemMenu.url}
          key={index}
        >
          {itemMenu.title}
        </NavLink>
      ))}

      {context.isLogged && (
        <NavLink
          exact
          activeClassName="active"
          className="nav-link"
          to={Routes.dashboard}
        >
          Mi Cuenta
        </NavLink>
      )}
    </Fragment>
  );
};

export const NavBar = (props: NavBarProps): ReactElement => {
  const { logos, id } = useBrand();
  const [expanded, setExpanded] = React.useState<boolean>(false);
  const [showLogin, setShowLogin] = React.useState<boolean>(false);
  const history = useHistory();
  const context = React.useContext<AuthenticationContext>(AuthContext);
  const alert = withReactContent(Swal);

  const { direction, isPastOffset } = useScrollDirection(10, 80);
  const isNavHidden = direction === 'down' && isPastOffset && !expanded;

  useEffect(() => {
    if (expanded) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('overflow');
    }
    return () => {
      document.body.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('overflow');
    };
  }, [expanded]);

  const handleShowLogin = () => {
    setShowLogin(true);
    setExpanded(false);
  };

  const closeSesion = () => {
    alert
      .fire({
        title: '¿Está seguro de cerrar sesión?',
        text: 'Al cerrar sesión no tendrá acceso a los datos de su línea.',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, cerrar sesión',
        showCloseButton: true,
        buttonsStyling: false,
        customClass: {
          popup: 'premium-swal2-popup',
          title: 'title-bryant text-dark',
          confirmButton: 'btn btn-danger rounded-pill px-4 py-2 mx-2 font-weight-bold',
          cancelButton: 'btn btn-light rounded-pill px-4 py-2 mx-2 font-weight-bold border',
        }
      })
      .then((result) => {
        if (result.isConfirmed) {
          handleLogOut();
        }
      });
  };

  const handleLogOut = () => {
    const repository = new AuthRepository();
    repository.removeToken();
    context.setIsLogged(false);
    setExpanded(false);
    history.push(Routes.root);
  };

  return (
    <>
      <Navbar
        expand="xl"
        expanded={expanded}
        onToggle={setExpanded}
        sticky={'top'}
        className={`shadow-sm main-nav bg-white navbar-elevaion${isNavHidden ? ' nav-hidden' : ''}`}
        id="mainNav"
      >
        <Container fluid className="special-container d-flex">
          <Navbar.Brand>
            <Link to="/">
              <img src={logos.main} className={logos.class} height="auto" />
            </Link>
          </Navbar.Brand>
          <button
            className={`navbar-toggler mobile-menu-toggle ${expanded ? 'is-open' : ''}`}
            onClick={() => setExpanded(!expanded)}
            aria-label={expanded ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={expanded}
          >
            <span className="toggler-bar top-bar" />
            <span className="toggler-bar mid-bar" />
            <span className="toggler-bar bot-bar" />
          </button>
          <Nav className="ml-auto mr-5 nav-menu d-none d-xl-flex">
            <ItemsMenu {...props} />
          </Nav>

          <button
            type="button"
            className="btn btn-account-pill d-none d-xl-flex align-items-center"
            onClick={context.isLogged ? closeSesion : handleShowLogin}
          >
            {context.isLogged ? (
              <>
                <SignOutIcon className="la-lg mr-2" /> Cerrar sesión
              </>
            ) : (
              <>
                <UserIcon className="la-lg mr-2" /> Mi Cuenta
              </>
            )}
          </button>
        </Container>
      </Navbar>
      <Login show={showLogin} handleClose={() => setShowLogin(false)} />
      <Drawer
        open={expanded}
        onClose={() => setExpanded(false)}
        direction="right"
        className={`zu-mobile-drawer theme-${id}`}
        size="85vw"
      >
        <div className={`theme-${id} d-flex flex-column h-100 w-100 bg-white`}>
          <div className="drawer-body flex-grow-1 px-3 overflow-auto">
            <Nav 
              className="flex-column nav-menu-mobile" 
              onClick={(e: React.MouseEvent) => {
                const target = e.target as HTMLElement;
                const link = target.closest('a') || target.closest('.dropdown-item');
                // Cierra el sidebar solo si se clickea un link final (no un toggle que despliega submenu)
                if (link && !link.classList.contains('dropdown-toggle')) {
                  setExpanded(false);
                }
              }}
            >
              <ItemsMenu {...props} isMobile={true} />
            </Nav>
          </div>
          <div className="drawer-footer p-4 bg-white">
            <button
              type="button"
              className="btn btn-account-pill w-100 d-flex justify-content-center align-items-center py-3 text-uppercase"
              style={{ fontSize: '1.05rem', fontWeight: 700 }}
              onClick={context.isLogged ? closeSesion : handleShowLogin}
            >
              {context.isLogged ? <>CERRAR SESIÓN</> : <>MI CUENTA</>}
            </button>
          </div>
        </div>
      </Drawer>
    </>
  );
};
